import { render } from "./Contactform.vue?vue&type=template&id=445458a8&scoped=true"
import script from "./Contactform.vue?vue&type=script&lang=js"
export * from "./Contactform.vue?vue&type=script&lang=js"

import "./Contactform.vue?vue&type=style&index=0&id=445458a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445458a8"]])

export default __exports__